import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignService, OrderService, LoaderService} from '../_services';
import {CrudSavePopupComponent} from '../_directives';
import {FormBuilder, Validators} from '@angular/forms';
import {Campaign, NewOrder} from "../_models";

@Component({
  moduleId: module.id.toString(),
  selector: 'smartlink-preview-form',
  templateUrl: './smartlink-preview-form.component.html'
})
export class SmartlinkPreviewFormComponent extends CrudSavePopupComponent implements OnInit {
  campaign: Campaign;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected alertService: AlertService,
    protected orderService: OrderService,
    protected campaignService: CampaignService,
    protected loaderService: LoaderService,
  ) {
    super(router, location, route, campaignService, alertService);
    this.objectName = 'Order';
    this.title = 'Enter Preview Customer';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({
      email: [null, [Validators.email]],
      phone: [null],
      customer_id: [null],
      order_id: [null],
      subscription_id: [null],
      product_id: [null],
      campaign_product_id: [null],
      variant_id: [null],
    }));
    this.campaign = this.campaignService.getCurrentCampaign();
    super.ngOnInit();
  }

  createNewOrder() {
    this.loaderService.show();

    this.orderService.sendTestOrder({campaign: this.campaign.id})
      .subscribe((orders: NewOrder[]) => {
        const customer = orders[0].customer;
        this.form.patchValue({
          customer_id: customer.customer_id,
          email: customer.email,
          phone: customer.phone,
          order_id: orders[0].order_id,
        });
        this.loaderService.hide();
      }, error => {
        this.loaderService.hide();
        this.handleError(error)
      });
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid) {
      this.onSave.emit(this.form.value);
    }
  }

}
